import React, { useEffect } from 'react';
import { IObject } from 'types';
import { Coords } from '../types';

export const getCoords = (ref: HTMLDivElement): Coords | null => {
  const box: DOMRect = ref.getBoundingClientRect();

  if (box) {
    return {
      left: box.left,
      top: box.top + box.height,
      width: box.width,
    };
  }

  return null;
};

// Принимает объект и массив объектов, по которому будет осуществлён поиск
export const checkCurrentCounter = (
  currentItem: IObject,
  params: IObject[]
): number => {
  let counter: number = 0;

  if (currentItem.inheritors) {
    params.forEach((item: IObject) =>
      currentItem.inheritors.forEach((inherit: IObject): void => {
        if (inherit.AOGUID === item.AOGUID) {
          counter++;
        }
      })
    );
  }

  if (currentItem.houses) {
    params.forEach((item: IObject): void =>
      currentItem.houses.forEach((house: IObject): void => {
        if (house._id === item._id) {
          counter++;
        }
      })
    );
  }
  return counter;
};

// Принимает объект и массив объектов, по которому будет осуществлён поиск
export const checkSelect = (
  currentItem: IObject,
  params: IObject[]
): boolean => {
  let check: boolean = false;

  params.forEach((item: IObject): void => {
    if (
      (currentItem.AOGUID && currentItem.AOGUID === item.AOGUID) ||
      (currentItem._id && currentItem._id === item._id) ||
      (currentItem.id && currentItem.id === item.id)
    ) {
      check = true;
    }
  });

  return check;
};

// Закрытие меню по клику вне нужного компонента и скролле
export function useCloseMenuOnScroll(
  ref: React.RefObject<any>,
  handler: (props: any) => void
) {
  useEffect(() => {
    const listener = (event: any) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };

    document.addEventListener('wheel', listener);
    return () => {
      document.removeEventListener('wheel', listener);
    };
  }, [ref, handler]);
}
